import { createGenericFetchAction } from 'ContentData/helpers/reduxHelpers';
import * as ctasClient from 'ContentData/api/Ctas';
import { CTAS_FETCH_CTA } from 'ContentData/actions/ActionTypes';
const fetchCtaAction = createGenericFetchAction(CTAS_FETCH_CTA, ctasClient.fetchCta);
export const fetchCta = guid => {
  return fetchCtaAction(guid);
};